import React from 'react';
import { Close } from '@mui/icons-material';
import { Box, Dialog, Divider, IconButton, ListItem } from '@mui/material';
import dayjs from 'dayjs';
import { observer } from 'mobx-react-lite';
import { mediumDate } from '/src/lib/constants';
import { Note } from '/src/lib/models';

export interface ViewNotesModalProps {
  /**
   * Notes to display
   */
  notes: Note[];
  /**
   * Whether this component is visible
   */
  open: boolean;
  /**
   * Sets component visibility
   * @param open Whether the component is visible
   * @returns void
   */
  setOpen: (open: boolean) => void;
  /**
   * Note display name
   */
  name?: string;
}

export const ViewNotesModal: React.FC<ViewNotesModalProps> = observer(({ name = 'Notes', notes, open, setOpen }) => {
  /** Render **/

  return (
    <Dialog open={open} aria-label="View Notes">
      <Box className="toolbar-div md-toolbar-tools" display="flex" justifyContent="space-between">
        <h2 className="md-subhead capitalize">{name}</h2>
        <IconButton className="md-icon-button" onClick={() => setOpen(false)} aria-label="Close">
          <Close className="md-icon material-icons" sx={{ color: 'white' }} />
        </IconButton>
      </Box>

      {/* STANDARD NOTES */}
      {notes.map((note) => (
        <Box key={note._id}>
          <ListItem sx={{ padding: '16px 16px 8px 16px' }}>
            {/* CONTENT */}
            <Box display="flex" flexDirection="column">
              <Box component="span" className="md-caption">
                Added {dayjs(note.created).format(mediumDate)}
                {note.user.displayName && ` by ${note.user.displayName}`}
              </Box>
              <p className="md-body-2">{note.content}</p>
            </Box>
          </ListItem>
          <Divider />
        </Box>
      ))}
    </Dialog>
  );
});
